import * as React from 'react';
import { SVGProps } from 'react';

const IconPipetteSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2s1.5-1.5 3 0 0 3 0 3l-2 2 1 1a1.414 1.414 0 0 1-2 2l-1-1-3.791 3.791-.21.2a5.835 5.835 0 0 1-3.916 1.51l-.117-.012a.585.585 0 0 1-.454-.455l-.012-.117c0-1.45.54-2.845 1.51-3.916l.199-.21L7 6.001 6 5a1.414 1.414 0 0 1 2-2l1 1 2-2Zm-6.73 8.852a4.336 4.336 0 0 0-1.142 2.02 4.335 4.335 0 0 0 2.02-1.141L8.94 7.94l-.878-.88-3.791 3.792Z"
    />
  </svg>
);
export default IconPipetteSizeS;
